export class TenantOverride {
  overrideToggles: OverrideToggle[];
  returnChargeWarningText?: string;
  informationCheckBoxText?: string;
}

export enum OverrideToggle {
  ShowReturnChargeWarning = 'ShowReturnChargeWarning',
  ShowInformationCheckBox = 'ShowInformationCheckBox'
}
